import { Link } from "react-router-dom";
import { User, signOut } from "firebase/auth";
import { auth } from "../firebase";
import { Button } from "./ui/button";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "./ui/navigation-menu";

interface TopNavProps {
  user: User | null;
}

const TopNav: React.FC<TopNavProps> = ({ user }) => {
  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <div className="w-full min-w-full border-b p-4 bg-cadet shadow-sm text-accent sticky top-0 z-1">
      <div className="flex flex-col md:flex-row md:items-center justify-between">
        <div className="flex items-center">
          <img
            src="data:image/svg+xml,%3csvg%20width='120'%20height='121'%20viewBox='0%200%20120%20121'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.37708%2063.772C8.00311%2090.8351%2029.6647%20112.497%2056.7279%20114.123L6.37708%2063.772ZM64.2515%20114.055C90.5306%20111.998%20111.498%2091.0304%20113.555%2064.7513L64.2515%20114.055ZM113.466%2055.2372C110.99%2029.7693%2090.7306%209.50963%2065.2627%207.03343L113.466%2055.2372ZM55.7367%206.94562C29.4671%209.00811%208.50824%2029.967%206.44576%2056.2366L55.7367%206.94562ZM-2.62268e-06%2060.4999C0%2093.637%2026.8629%20120.5%2060%20120.5C93.1371%20120.5%20120%2093.637%20120%2060.4999C120%2027.3628%2093.1371%200.499872%2060%200.499873C26.8629%200.499875%20-4.07115e-06%2027.3628%20-2.62268e-06%2060.4999ZM109.388%2060.0386L94.5238%2074.9028C88.9785%2067.9436%2081.4226%2062.6517%2072.7336%2059.9086C81.3624%2057.1846%2088.874%2051.947%2094.4085%2045.0592L109.388%2060.0386ZM89.9381%2040.5888L79.2774%2029.9281C71.6444%2036.0879%2066.3854%2045.0599%2065.0704%2055.2664C75.1488%2053.7152%2083.9563%2048.307%2089.9381%2040.5888ZM60.5551%2046.677C63.1982%2038.2893%2068.2159%2030.9562%2074.8159%2025.4666L60.4558%2011.1065L46.1858%2025.3765C52.8394%2030.8758%2057.8977%2038.2434%2060.5551%2046.677ZM56.0825%2055.6084C45.4523%2054.7992%2036.0123%2049.7307%2029.4649%2042.0974L41.7227%2029.8396C49.5007%2036.0701%2054.8361%2045.2113%2056.0825%2055.6084ZM56.1694%2064.2018C55.1182%2074.7959%2049.8295%2084.1442%2042.0136%2090.5286L29.3445%2077.8594C35.9141%2070.127%2045.4385%2064.9945%2056.1694%2064.2018ZM46.4729%2094.9878C52.9848%2089.515%2057.936%2082.2384%2060.5551%2073.9263C63.1598%2082.1925%2068.0709%2089.4346%2074.5296%2094.8969L60.4558%20108.971L46.4729%2094.9878ZM90.051%2079.3756L78.9875%2090.4391C71.3136%2084.1245%2066.0985%2074.9432%2064.9755%2064.5361C75.1573%2066.0778%2084.0489%2071.5547%2090.051%2079.3756ZM25.014%2046.5484L11.5237%2060.0386L24.8921%2073.407C30.3005%2067.1851%2037.3825%2062.4513%2045.4383%2059.9082C37.4428%2057.384%2030.4066%2052.7017%2025.014%2046.5484Z'%20fill='black'/%3e%3c/svg%3e"
            alt="Plaza Logo"
            className="h-8 w-auto mx-4"
          />
          <NavigationMenu>
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link className="hover:bg-accent" to="/accounts">
                    Accounts
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link className="hover:bg-accent" to="/properties">
                    Properties
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link className="hover:bg-accent" to="/system-status">
                    System Status
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>
        <div className="flex items-center gap-4">
          <span>
            <em>{user?.email}</em>
          </span>
          <Button
            onClick={handleLogout}
            className="bg-foreground hover:bg-accent hover:text-foreground rounded cursor-pointer"
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
